var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container",attrs:{"id":"app"}},[_c('div',{staticClass:"main-content"},[_c('router-view',{key:_vm.$route.path})],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icp-footer-global"},[_c('a',{staticClass:"icp-link",attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" 备案号:蜀ICP备2024097752号-2 ")])])
}]

export { render, staticRenderFns }